import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

const FileUpload = () => {
  const loader = useSelector((state) => state?.auth?.loader)
  const [loading, setLoading] = useState(loader);

  const handleSubmit = () => {
    setLoading(loader);

  };
  useEffect(() => {
    handleSubmit()
  }, [loader])
  return (
    <div>
      {/* Overlay */}
      {loading && <div className="overlay fixed inset-0 bg-black bg-opacity-75 z-[999]"></div>}

      {/* Loader and message */}
      {loading && (
        <div className="spanner absolute top-1/2 left-0 w-full text-white text-center transform -translate-y-1/2 z-[1000] p-6 transition-opacity duration-300 opacity-100">
          <div className="loader mx-auto mb-5"></div>
          <p>Loading...</p>
        </div>
      )}
    </div>

  );
};

export default FileUpload;
